export default __webpack_public_path__ + "5012e91f0fed479f79b38db668767448.ttf";